import { render } from "./Loading.vue?vue&type=template&id=c3967f50"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=c3967f50&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__